// Ported from the React user app's inline i18next resources:
//   - src/user/i18n.js  (EN + DE, a single flat "translation" namespace)
// Keys are flat snake_case; strings keep their i18next {{var}} interpolation
// placeholders. German is deliberately incomplete — keys the React DE map never
// defined are left absent here too, and i18n.svelte.js falls back to English.
//
// Three defects in the React DE map are corrected here rather than carried over;
// each correction is commented inline at the key.

const baseEn = {
  add_remove_asset_pairs: "Add/Remove Trading Pairs",
  trading: "Trading Pairs",
  tradingTitle: "Trading",
  edit: "Edit",
  title: "Title",
  try_to_refresh: "Try to refresh this page.",
  refresh: "Refresh",
  no_asset_configured: "There is no asset configured",
  contact_to_add_asset: "Contact support to add new asset",
  coin_address: "Coin Address",
  error_price_feed: "Error occured while connecting to price feed",
  hide_filters: "Hide filters",
  display_filters: "Display filters",
  hide_withdraw: "Hide withdraw panel",
  show_withdraw: "Show withdraw panel",
  update_successful: "Update successful",
  sucessfully_added_pair: "You successfully added new pair",
  error_occured: "Some error occured",
  successfully_updated_pair: "You successfully updated form to display pair",
  filter_trades: "Filter trades",
  filter: "Filter",
  buy: "Buy",
  sell: "Sell",
  buy_l: "buy",
  sell_l: "sell",
  accept: "Accept",
  decline: "Decline",
  size_min: "Size min",
  size_max: "Size max",
  trade_id: "Operation ID",
  type: "Type",
  date_from: "Date from",
  date_to: "Date to",
  trades_history: "Trades history",
  size: "Size",
  search: "Search",
  trade_value: "Trade value",
  price: "Price",
  time: "Time",
  add_new_pair: "Add new trading pair",
  edit_trade_form: "Edit trading pairs",
  update_form: "Update form",
  pair_shown: "Pairs shown",
  close: "Close",
  confirmation: "Confirmation",
  add_pair: "Add pair",
  update_trade_settings: "Update trading pairs",
  bad_request: "Bad Request",
  request_result_error: "Your Request resulted in an error",
  back_to_homepage: "Back to Homepage",
  forbidden: "Forbidden",
  no_permission: "You do not have permission to view this resource",
  was_not_found: "The page you were looking for was not found",
  address_mistyped: "You may have mistyped the address or the page may have been moved",
  internal_server_error: "Internal Server Error",
  service_unavailable: "Service Unavailable",
  want_to_add_key: "Do you want to add new API Key for client",
  adding_new_key: "Adding new API Key",
  new_api_key: "New API Key",
  generate_callback_secret: "Generate callback secret",
  cancel: "Cancel",
  create_api_key: "Create API Key",
  write_down_secret: "Please write down new API Key secret",
  write_down_callbacl_secret: "Please write down new callback secret",
  key: "Key",
  secret: "Secret",
  closing_api_key_window:
    "After closing this window You will not be able to retrieve API Key secret",
  closing_callback_secret_window:
    "After closing this window You will not be able to retrieve callback secret",
  api_key_created: "API Key created",
  generated_callback_secret: "Callback secret generated",
  saved_secret: "I saved the API Key secret",
  saved_callback_secret: "I saved the callback secret",
  api_keys: "API Keys",
  api_key_deleted: "API Key deleted",
  api_key_delete_success: "API Key was successfully deleted",
  about_to_delete_key: "You are about to delete API Key",
  client: "Client",
  clients_summary: "Clients Summary",
  assets_summary: "Assets Summary",
  supported_assets: "Supported assets",
  want_to_continue: "Do you want to continue?",
  deleting_api_key: "Deleting API Key",
  delete_api_key: "Delete API Key",
  active_api_keys: "Active API Keys",
  delete: "Delete",
  assets: "Assets",
  trading_config: "Trading config",
  primary: "Primary",
  secondary: "Secondary",
  min_trade: "Min. trade",
  max_trade: "Max. trade",
  assets_config: "Assets config",
  code: "Code",
  deposits: "Deposits",
  min_withdrawal: "Min. withdrawal",
  withdrawal_fee: "Withdrawal fee",
  successfully_created_deposit_address: "You successfully created new deposit address",
  label: "Label",
  address: "Address",
  creating_address_successful: "Creating address was successful",
  deposit_info: "Bank deposits",
  deposit_info_details: "Bank deposit info",
  deposit_addresses_title: "Crypto deposits",
  deposit_addresses: "Deposit addresses",
  available_deposit_addresses: "Available deposit addresses for {{transactionNetwork}}",
  new_deposit_address: "New deposit address",
  initial: "Initial",
  pending: "Pending",
  settled: "Settled",
  success: "Success",
  failure: "Failure",
  partial: "Partial",
  amlreview: "In review",
  filter_deposits: "Deposits Filter",
  filter_invoices: "Payment Links Filter",
  invoice_payments: "Payments",
  amount_min: "Amount min",
  amount_max: "Amount max",
  min_eur_value: "EUR value min",
  max_eur_value: "EUR value max",
  currency: "Currency",
  status: "Status",
  deposit_id: "Deposit ID",
  transaction: "Transaction",
  transaction_network: "Transaction Network",
  transaction_fee: "Transaction Fee paid by the payer",
  next: "Next",
  back: "Back",
  invoice_submitted_for_review: "Payment link submitted for MLRO review",
  invoice_payer_address: "Payer crypto wallet address",
  invoice_payer_address_required: "A payer address is required.",
  invoice_address_unsupported: "Unrecognised or unsupported address",
  invoice_payer_unknown: "I don't know the payer's crypto address",
  invoice_supporting_documents: "Supporting documents",
  invoice_compliance_documents: "Compliance documents",
  invoice_additional_documents: "Additional documents (optional)",
  invoice_additional_comments: "Additional comments (optional)",
  invoice_additional_comments_placeholder:
    "Any extra context for the compliance reviewer (optional)",
  invoice_document_not_applicable: "Not applicable",
  invoice_compliance_documents_required:
    "Every compliance document must be uploaded or marked as not applicable",
  invoice_upload_documents: "Upload files",
  // Names the file and how big it actually is: with four slots and several files in flight, "each file must be
  // 10 MB or smaller" left the creator guessing which one to replace.
  invoice_document_too_large: "{{filename}} is {{size}} — each file must be {{limit}} or smaller",
  invoice_documents_too_many: "You can attach at most 10 files",
  invoice_document_uploading: "Uploading…",
  invoice_documents_uploading: "Wait for the documents to finish uploading",
  invoice_copy_from_previous: "Copy from previous",
  invoice_copy_title: "Copy from a previous payment link",
  invoice_copy_search_placeholder: "Search by name",
  invoice_copy_note:
    "Pick a payment link to fill this step in from it — the payer address, the compliance documents and the comments you submitted with it. The documents are not uploaded again.",
  // Only payment links submitted through this review step have anything to copy, which is not obvious
  // from the list, so the empty state says what would qualify rather than just "nothing here".
  invoice_copy_empty: "You have no previously submitted payment links to copy from yet",
  invoice_copy_no_matches: "No payment link matches that search",
  invoice_copy_in_progress: "Copying…",
  // Named, not counted: the creator has to know which file to go and find.
  invoice_copy_documents_refused:
    "These documents were uploaded by another user and must be attached again: {{filenames}}",
  invoice_discard_title: "Discard this payment link?",
  invoice_discard_message:
    "Everything you entered here, including any uploaded documents, will be lost.",
  creating: "Creating…",
  discard: "Discard",
  keep_editing: "Keep editing",
  form_has_errors: "Please correct the highlighted fields",
  description: "Description",
  details: "Details",
  deposit_details: "Deposit details",
  asset: "Asset",
  create_deposit_address: "Create new deposit address",
  edit_deposit_address: "Edit deposit address",
  generate_deposit_address: "Generate new deposit address",
  payment_method: "Payment Method",
  label_name: "Label name",
  label_id: "Label ID",
  copy_to_clipboard: "Copy to clipboard",
  copied: "Copied",
  client_name: "Client Name",
  client_id: "Client ID",
  beneficiary_name: "Beneficiary Name",
  beneficiary_address: "Beneficiary Address",
  bank_name: "Bank Name",
  bank_address: "Bank Address",
  include_reference_code: "Please include the following reference code when sending us funds",
  invalid_address: "Invalid {{transactionNetwork}} address",
  invalid_address_eip55: "Invalid {{transactionNetwork}} address (EIP-55 validation unsuccessful)",
  select_transaction_network: "Please select transaction network",
  euro_value: "EURO value",
  euro_deposits: "Euro deposits",
  gbp_deposits: "GBP deposits",
  send_euro_to_bank: "Please send all Euro deposits to the following bank account",
  send_gbp_to_bank: "Please send all GBP deposits to the following bank account",
  error: "Error",
  error_requesting_data: "Some error occured while requesting data",
  payout: "Payout",
  trade: "Trade",
  deposit: "Deposit",
  withdraw: "Withdraw",
  filter_ledger: "Ledger Filter",
  filter_users_list: "Users List Filter",
  filter_mlro: "MLRO Report Filter",
  category: "Category",
  operation_id: "Operation ID",
  amount: "Amount",
  fees: "Fees",
  fee: "Fee",
  balance_after: "Balance after",
  logged_out: "Logged out",
  you_logged_out: "You have been logged out",
  no_clients_exists: "No clients exists for this account",
  clients_load_failed: "Could not load your clients",
  sign_in_failed: "Could not complete your sign in",
  try_again: "Try again",
  notifications: "Notifications",
  contact_to_create_clients: "Please contact us to create clients for your account",
  sold: "sold",
  save: "Save",
  settings: "Settings",
  updated_user_settings: "User settings have been successfully saved",
  users_list: "Users list",
  user_id: "User ID",
  is_admin: "Admin",
  bought: "bought",
  trade_successful: "Trade successful",
  you_successfully: "You successfully",
  for: "for",
  no_pair_configured: "There is no asset pair configured",
  contact_to_add_asset_pair: "Contact support to add new asset pair",
  withdrawal_successful: "Withdrawal successful",
  successfully_posted_withdrawal: "You successfully posted withdrawal of",
  successfully_created_withdrawal_address: "You successfully created new withdrawal address",
  successfully_updated_withdrawal_address: "You successfully updated withdrawal address",
  updating_address_successful: "Updating address was successful",
  successfully_deleted_withdrawal_address: "You successfully deleted withdrawal address",
  deleting_address_successful: "Deleting address was successful",
  withdrawals: "Withdrawals",
  withdrawal_addresses: "Withdrawal addresses",
  crypto_addresses: "Crypto addresses",
  bank_addresses: "Bank accounts",
  withdrawal_method: "Withdrawal method",
  new_withdrawal_address: "Add new withdrawal address",
  new_bank_address: "Add new bank account",
  approve_to_make_withdrawal:
    "You must add a withdrawal address for this currency before you can send any withdrawals",
  make_withdrawal: "Make withdrawal",
  min_deposit: "Minimum deposit",
  min_deposit_amounts: "Minimum deposit amounts",
  filter_withdrawals: "Withdrawals Filter",
  filter_payouts: "Payouts Filter",
  withdrawal_id: "Withdrawal ID",
  withdrawals_history: "Withdrawals history",
  payouts_history: "Payouts history",
  reference_id: "Reference ID",
  payout_amount: "Payout amount",
  source_amount: "Source amount",
  provide_valid_address: "Please provide valid address",
  provide_valid_iban: "Please provide valid IBAN number",
  provide_valid_bic: "Please provide valid BIC code",
  unique_label_coin: "Create a unique label name to assign to this coin address",
  unique_label_bank: "Create a unique label name to assign to this bank account",
  iban_number: "IBAN/Account number",
  bic_code: "BIC code",
  name_bank: "Name of a bank",
  address_bank: "Address of a bank",
  iban_description: "The IBAN/Account number of the bank account",
  bic_description: "The BIC/SWIFT number of the bank",
  bank_description: "The name of the bank, not the branch",
  bank_address_description: "The address of the bank, not the branch",
  name_beneficiary: "Name of beneficiary",
  beneficiary_name_description:
    "The name of the company listed on the bank account you wish to send funds to. This cannot be an individual, and it must be a company name",
  beneficiary_address_description: "The registered address of the company for this bank account",
  address_beneficiary: "Address of beneficiary",
  create_withdrawal_address: "Create new withdrawal address",
  create_bank_withdrawal_address: "Add new bank account",
  delete_address_description: "You are about to delete withdrawal address",
  deleting_withdrawal_address: "Deleting Withdrawal Address",
  delete_withdrawal_address: "Delete withdrawal address",
  address_details: "Address details",
  update_withdrawal_address: "Update withdrawal address",
  update_address: "Update address",
  pair: "Pair",
  tenant_name: "Tenant",
  delete_pair_question: "Do you want to delete pair",
  deleting_trading_pair: "Deleting trading pair",
  yes_delete_pair: "Yes, delete pair",
  deleting_successful: "Deleting successful",
  successfully_deleted_pair: "You successfully deleted pair",
  estimated_values_assets: "Estimated values asset",
  field_required: "Field is required",
  want_to_create_trade: "Do you want to create new {{type}} trade for {{amountSubmit}} {{asset}} ?",
  new_trading_offer_exchange:
    "{{operation}} {{primaryAmount}} {{primaryAsset}} for {{secondaryAmount}} {{secondaryAsset}}",
  new_payout_offer_exchange: "Payout: {{payoutAmount}} {{payoutAsset}}",
  new_trading_offer_rate: "Exchange rate for this offer: {{rate}}",
  new_trading_offer_fees: "Fees: {{feeAmount}} {{feeAsset}}",
  new_trading_offer_no_fees: "Offered exchange rate includes all transaction fees",
  new_payout_offer_fees: "Fees: {{totalFeesInSourceAsset}} {{sourceAsset}}",
  new_payout_offer_total_cost: "Total cost: {{totalCostInSourceAsset}} {{sourceAsset}}",
  posting_new_trade: "Posting new trade",
  exchange_rate: "Exchange rate",
  trading_offer: "Trade Offer",
  payout_offer: "Payout Offer",
  payout_details: "Payout Details",
  requesting_new_trade: "Requesting Trade Offer",
  requesting_new_payout: "Requesting Payout Offer",
  yes_create_trade: "Yes, create trade",
  number_at_min: "Number should be at min",
  amount_buy_sell: "Amount to buy/sell",
  amount_spend_receive: "Amount to spend/receive",
  spend: "Spend",
  receive: "Receive",
  buy_price: "Buy price",
  sell_price: "Sell price",
  balances: "Balances",
  no_balances: "No balances",
  copyright: "Copyright",
  all_rights_reserved: "All Rights Reserved",
  selected_client: "Selected client",
  logout: "Logout",
  dashboard: "Dashboard",
  select_client: "Select client",
  trading_panel: "Trading panel",
  ledger: "Ledger",
  mlro: "MLRO Report",
  email_invalid: "Email is invalid",
  send_email: "Send email",
  email: "Email",
  removing_2fa_successful: "Two-Factor Authentication Removed Successful",
  value_invalid: "Value is invalid",
  id_invalid: "ID is invalid",
  operation_id_invalid: "Operation ID is invalid",
  trade_id_invalid: "Trade ID is invalid",
  withdrawal_id_invalid: "Withdrawal ID is invalid",
  address_invalid: "Address is invalid",
  date_invalid: "Date is invalid",
  insufficient_funds: "Insufficient funds. You have {{amountToSpend}} {{spendCurrency}} to spend",
  type_error: "Value should be a {{type}}",
  length_error: "Value should be exactly {{length}} characters",
  min_error: "Value should be at least {{min}} characters",
  max_error: "Value shouldn't be more than {{max}} characters",
  min_number_error: "Number should be at min {{min}}",
  max_number_error: "Number should be at max {{max}}",
  less_number_error: "Number should be less than {{max}}",
  should_be_more: "Value should be more than {{min}}",
  export: "Export",
  panel: "Panel",
  change_language: "Change language",
  approved: "Approved",
  field_digits_message: "Field must have {{count}} digits after decimal or less",
  bank_withdrawal: "Bank withdrawal",
  qr_code: "QR code",
  sign_up: "Sign up",
  client_info: "Client info",
  current_fee: "Current fee",
  client_fees: "Client fees",
  current_trade_volume: "Current trade volume",
  tx_fee_schedule: "Fee schedule",
  volume_needed_for_next_tier: "Volume needed for next tier",
  client_api_keys: "Client API Keys",
  workflows: "Workflows",
  external_id: "External ID",
  no_options: "No options",
};

const baseDe = {
  no_options: "Keine Optionen",
  trading: "Handel",
  tradingTitle: "Handel",
  edit: "Bearbeiten ",
  try_to_refresh: "Bitte die Seite aktualisieren",
  refresh: "Aktualisieren",
  no_asset_configured: "Kein Asset konfiguriert",
  contact_to_add_asset: "Um ein neues Asset hinzuzufügen, bitte kontaktieren Sie den Support",
  error_price_feed: "Beim Verbinden mit dem Preisfeed ist ein Fehler aufgetreten",
  hide_filters: "Filter ausblenden",
  display_filters: "Filter einblenden",
  hide_withdraw: "Auszahlungsbereich ausblenden",
  show_withdraw: "Auszahlungsbereich einblenden",
  update_successful: "Aktualisierung erfolgreich",
  sucessfully_added_pair: "Sie haben ein neues Paar erfolgreich hinzugefügt",
  error_occured: "Es ist ein Fehler aufgetreten",
  successfully_updated_pair: "Sie haben den Formular: 'Paar anzeigen' erfolgreich aktualisiert",
  filter_trades: "Trades filtern",
  filter: "Filtern",
  buy: "Kaufen",
  sell: "Verkaufen",
  buy_l: "kaufen",
  sell_l: "verkaufen",
  size_min: "Größe min",
  size_max: "Größe max",
  trade_id: "Handel-ID",
  type: "Typ",
  date_from: "Datum von",
  date_to: "Datum bis",
  trades_history: "Handel Histiorie",
  size: "Größe",
  trade_value: "Handelswert",
  price: "Preis",
  time: "Zeit",
  add_new_pair: "Neues Handelspaar hinzufügen",
  edit_trade_form: "Handelsformular bearbeiten",
  update_form: "Formular aktualisieren",
  pair_shown: "Paar gezeigt",
  close: "Schließen",
  add_pair: "Neue Paar hinzufügen",
  update_trade_settings: "Handeleinstellungen aktualisieren",
  bad_request: "Falsche Anfrage",
  request_result_error: "Ihre Anfrage führte zu einem Fehler",
  back_to_homepage: "Zur Startseite",
  forbidden: "Verboten",
  no_permission: "Sie sind nicht berechtigt, diese Ressource anzuzeigen",
  was_not_found: "Die gesuchte Seite wurde nicht gefunden",
  address_mistyped:
    "Möglicherweise haben Sie sich bei der Adresse vertippt oder die Seite wurde verschoben",
  internal_server_error: "Interner Serverfehler",
  service_unavailable: "Service nicht verfügbar",
  want_to_add_key: "Möchten Sie einen neuen Client API-Schlüssel hinzufügen?",
  adding_new_key: "Neuen API-Schlüssel hinzufügen",
  new_api_key: "Neuer API-Schlüssel",
  cancel: "Abbrechen",
  create_api_key: "API-Schlüssel anlegen",
  write_down_secret: "Bitte notieren Sie sich das neue API-Schlüsselgeheimnis",
  key: "Schlüssel",
  secret: "Geheimnis",
  closing_api_key_window:
    "Wenn Sie dieses Fenster schliessen, wird der Abruf des API-Schlüsselgeheimnises nicht möglich",
  api_key_created: "API-Schlüssel wurde erstellt",
  saved_secret: "API-Schlüsselgeheimnis wurde gespeichert",
  api_keys: "API-Schlüssel",
  api_key_deleted: "API-Schlüssel wurde gelöscht",
  api_key_delete_success: "API-Schlüssel wurde erfolgreich gelöscht",
  about_to_delete_key: "Sie sind dabei, den API-Schlüssel zu löschen",
  client: "Kunde",
  want_to_continue: "Wollen Sie fortfahren?",
  deleting_api_key: "Entfernung API-Schlüssel",
  delete_api_key: "API-Schlüssel entfernen",
  active_api_keys: "Aktive API-Schlüssel",
  delete: "Löschen",
  assets: "Assets",
  trading_config: "Handelskonfiguration",
  primary: "Primär",
  secondary: "Sekundär",
  min_trade: "Minimal handeln",
  max_trade: "Maximal handeln",
  assets_config: "Assets-Konfiguration",
  code: "Code",
  deposits: "Einlagen",
  min_withdrawal: "Minimal Rückzug",
  withdrawal_fee: "Abhebegebühr",
  successfully_created_deposit_address:
    "Sie haben erfolgreich die neue Einzahlungsadresse angelegt",
  label: "Label",
  address: "Adresse",
  creating_address_successful: "Die Adresse wurde erfolgreich erstellt",
  deposit_info: "Informationen zur Einzahlung",
  deposit_addresses: "Einzahlungsadressen",
  // React's DE dropped the {{transactionNetwork}} placeholder this key carries in
  // English (it read only "Einzahlungsadressen"); restored so German still names
  // the network. Same fix the admin-svelte migration applied.
  available_deposit_addresses: "Einzahlungsadressen für {{transactionNetwork}}",
  new_deposit_address: "Neue Einzahlungsadresse",
  initial: "Initial",
  pending: "Ausstehend",
  settled: "Angesiedelt",
  success: "Erfolg",
  failure: "Fehler",
  partial: "Teilweise",
  amlreview: "In Prüfung",
  filter_deposits: "Ablagerungen filtern",
  amount_min: "Betrag min",
  amount_max: "Betrag max",
  currency: "Währung",
  status: "Status",
  deposit_id: "Einzahlungs-ID",
  transaction: "Transaktion",
  description: "Beschreibung",
  details: "Einzelheiten",
  deposit_details: "Einzahlungsdetails",
  asset: "Asset",
  create_deposit_address: "Neue Einzahlungsadresse erstellen",
  edit_deposit_address: "Einzahlungsadresse bearbeiten",
  generate_deposit_address: "Neue Einzahlungsadresse erstellen",
  label_name: "Label name",
  label_id: "Label ID",
  copy_to_clipboard: "In die Zwischenablage kopieren",
  copied: "Kopiert",
  beneficiary_name: "Name des Begünstigten",
  beneficiary_address: "Begünstigtenadresse",
  bank_name: "Bankname",
  bank_address: "Bankadresse",
  include_reference_code:
    "Bitte geben Sie den folgenden Referenzcode an, wenn Sie uns Gelder senden",
  euro_deposits: "Euro-Einlagen",
  gbp_deposits: "GBP-Einlagen",
  send_euro_to_bank: "Bitte überweisen Sie alle Euro-Einzahlungen auf das folgende Bankkonto",
  send_gbp_to_bank: "Bitte überweisen Sie alle GBP-Einzahlungen auf das folgende Bankkonto",
  error: "Fehler",
  error_requesting_data: "Beim Anfordern von Daten ist ein Fehler aufgetreten",
  payout: "Geld auszahlen",
  trade: "Handeln",
  deposit: "Anzahlung",
  withdraw: "Abheben",
  filter_ledger: "Ledger filtern",
  category: "Kategorie",
  operation_id: "Vorgangs-ID",
  amount: "Betrag",
  fees: "Honorare",
  fee: "Honorare",
  balance_after: "Bilanz nach",
  logged_out: "Abgemeldet",
  you_logged_out: "Sie wurden ausgeloggt",
  no_clients_exists: "Für dieses Konto sind keine Kunden vorhanden",
  clients_load_failed: "Ihre Kunden konnten nicht geladen werden",
  sign_in_failed: "Ihre Anmeldung konnte nicht abgeschlossen werden",
  try_again: "Erneut versuchen",
  contact_to_create_clients: "Bitte kontaktieren Sie uns, um Kunden für Ihr Konto zu erstellen",
  sold: "Verkauft",
  bought: "Gekauft",
  trade_successful: "Handel erfolgreich",
  you_successfully: "Sie erfolgreich",
  for: "für",
  no_pair_configured: "Es ist kein Asset-Paar konfiguriert",
  contact_to_add_asset_pair:
    "Kontaktieren Sie bitte den Support, um ein neues Asset-Paar hinzuzufügen",
  withdrawal_successful: "Auszahlung erfolgreich",
  successfully_posted_withdrawal: "Sie haben erfolgreich die Auszahlung gebucht von",
  successfully_created_withdrawal_address:
    "Sie haben die neue Auszahlungsadresse erfolgreich erstellt",
  successfully_updated_withdrawal_address:
    "Sie haben die Auszahlungsadresse erfolgreich aktualisiert",
  updating_address_successful: "Der Adresse wurde erfolgreich aktualisiert",
  successfully_deleted_withdrawal_address: "Die Auszahlungsadresse wurde erfolgreich gelöscht",
  deleting_address_successful: "Die Adresse wurde erfolgreich gelöscht",
  withdrawals: "Abhebungen",
  withdrawal_addresses: "Auszahlungsadressen",
  crypto_addresses: "Auszahlungsadressen",
  bank_addresses: "Auszahlungsadressen",
  withdrawal_method: "Withdrawal method",
  new_withdrawal_address: "Neue Auszahlungsadresse hinzufügen",
  new_bank_address: "Neue Bankadresse hinzufügen",
  approve_to_make_withdrawal:
    "Sie müssen zuerst eine Auszahlungsadresse für diese Währung definieren und diese Adresse muss bei uns genehmigt werden, um eine Auszahlung vorzunehmen",
  make_withdrawal: "Auszahlung vornehmen",
  filter_withdrawals: "Auszahlungen filtern",
  withdrawal_id: "Auszahlung-ID",
  withdrawals_history: "Auszahlungshistorie",
  reference_id: "Reference ID",
  provide_valid_address: "Bitte eine gültige Adresse angeben",
  provide_valid_iban: "Bitte geben Sie eine gültige IBAN-Nummer an",
  provide_valid_bic: "Bitte geben Sie einen gültigen BIC-Code an",
  unique_label_coin:
    "Erstellen Sie bitte einen eindeutigen Labelnamen, um dieser Münzadresse zuzuweisen",
  unique_label_bank:
    "Erstellen Sie bitte einen eindeutigen Labelnamen, der diesem Bankkonto zugewiesen wird",
  iban_number: "IBAN-Nummer",
  bic_code: "BIC Code",
  name_bank: "Bankname",
  address_bank: "Bankadresse",
  iban_description: "Die IBAN des Bankkontos",
  bic_description: "Die BIC/SWIFT-Nummer der Bank",
  bank_description: "Der Name der Bank, nicht der Filiale",
  bank_address_description: "Die Adresse der Bank, nicht der Filiale",
  name_beneficiary: "Name des Begünstigten",
  beneficiary_name_description:
    "Der Name des Unternehmens, das auf dem Bankkonto aufgeführt ist, an das Sie Geld senden möchten. Dies kann keine indiviruelle sein, und muss eine Firmenname sein",
  beneficiary_address_description: "Die registrierte Adresse des Unternehmens für dieses Bankkonto",
  address_beneficiary: "Adresse des Begünstigten",
  create_withdrawal_address: "Neue Abhebungsadresse erstellen",
  create_bank_withdrawal_address: "Neue Bankadresse erstellen",
  delete_address_description: "Sie sind dabei, die Abhebungsadresse zu löschen",
  deleting_withdrawal_address: "Entfernung die Abhebungsadresse",
  delete_withdrawal_address: "Abhebungsadresse löschen",
  address_details: "Adressen Details",
  update_withdrawal_address: "Abhebungsadresse aktualisieren",
  update_address: "Adresse aktualisieren",
  pair: "Pair",
  delete_pair_question: "Möchten Sie das Pair löschen?",
  deleting_trading_pair: "Handelspair löschen",
  yes_delete_pair: "Ja, Pair löschen",
  deleting_successful: "Entfernung erfolgreich",
  successfully_deleted_pair: "Sie haben das Paar erfolgreich gelöscht",
  field_required: "Das Feld ist erforderlich",
  want_to_create_trade:
    "Möchten Sie {{type}} neu erstellen und eintauschen für {{amountSubmit}} {{asset}} ?",
  posting_new_trade: "Neuen Handel buchen",
  yes_create_trade: "Ja, Handel erstellen",
  number_at_min: "Die Anzahl sollte mindestens sein",
  amount_buy_sell: "Betrag zu kaufen/verkaufen",
  // React's DE misspelled this key as `amount_spend_recieve`, so it never matched
  // the English `amount_spend_receive` and the German string was dead weight.
  amount_spend_receive: "Betrag, den Sie ausgeben/erhalten möchten",
  buy_price: "Kaufpreis",
  sell_price: "Verkaufspreis",
  balances: "Guthaben",
  no_balances: "Keine Guthaben",
  copyright: "Urheberrechte",
  all_rights_reserved: "Alle Rechte vorbehalten",
  selected_client: "Ausgewählter Kunde",
  logout: "Ausloggen",
  dashboard: "Dashboard",
  select_client: "Kunden auswählen",
  trading_panel: "Handelspanel",
  ledger: "Hauptbuch",
  email_invalid: "E-Mail ist ungültig",
  value_invalid: "Die Wert ist ungültig",
  id_invalid: "Ausweis ist ungültig",
  operation_id_invalid: "Vorgangs-ID ist ungültig",
  trade_id_invalid: "Handel-ID ist ungültig",
  withdrawal_id_invalid: "Auszahlung-ID ist ungültig",
  address_invalid: "Adresse ist ungültig",
  date_invalid: "Datum ist ungültig",
  insufficient_funds: "Unzureichende Mittel. Du hast  {{amountToSpend}} {{spendCurrency}} ausgeben",
  type_error: "Der Wert sollte {{type}} sein",
  length_error: "Der Wert sollte genau {{length}} Zeichen lang sein",
  min_error: "Der Wert sollte mindestens {{min}} Zeichen lang sein",
  max_error: "Der Wert sollte nicht mehr als {{max}} Zeichen lang sein",
  min_number_error: "Zahl sollte min {{min}} sein",
  // React's DE wrote this as a JS template literal `${max}`, which i18next never
  // interpolates — German users saw a literal "${max}". Corrected to {{max}}.
  max_number_error: "Anzahl sollte max. {{max}} betragen",
  should_be_more: "Wert sollte mehr als {{min}} betragen",
  export: "Ausfuhr",
  panel: "Panel",
  change_language: "Sprache ändern",
  approved: "Genehmigt",
  field_digits_message: "Das Feld sollte genau {{count}} Dezimalstellen oder weniger haben",
  bank_withdrawal: "Bankabhebung",
  qr_code: "QR code",
  sign_up: "Registrieren",
  client_info: "Kunde Info",
  client_fees: "Kundengebühren",
  current_fee: "Aktuelle Gebühr",
  current_trade_volume: "Aktuelles Handelsvolumen",
  tx_fee_schedule: "Gebührenordnung",
  volume_needed_for_next_tier: "Volumen für die nächste Stufe benötigt",
  client_api_keys: "Kunde API-Schlüssel",
};

// Sidebar navigation labels.
//
// React's `pagesListing` (src/user/routes/index.jsx) ran some entries through t()
// — "balances", "client_info", "deposits", "ledger", "tradingTitle", "withdrawals",
// "workflows" — and hardcoded the rest as raw English literals that t() could never
// resolve: "Deposit Addresses", "Payment Link", "Payouts". Here every entry gets a
// real key, reusing the existing translation wherever React already had one.
const navEn = {
  nav_trading: "Trading",
  nav_balances: "Balances",
  nav_deposits: "Deposits",
  nav_deposit_addresses: "Deposit Addresses",
  nav_withdrawals: "Withdrawals",
  nav_payouts: "Payouts",
  nav_payment_links: "Payment Link",
  nav_workflows: "Workflows",
  nav_ledger: "Ledger",
  nav_client: "Client info",
};
const navDe = {
  nav_trading: "Handel",
  nav_balances: "Guthaben",
  nav_deposits: "Einlagen",
  nav_deposit_addresses: "Einzahlungsadressen",
  nav_withdrawals: "Abhebungen",
  nav_payouts: "Auszahlungen",
  nav_payment_links: "Zahlungslink",
  nav_workflows: "Workflows",
  nav_ledger: "Hauptbuch",
  nav_client: "Kunde Info",
};

// Labels for chrome the React dashboard did not have (the per-account light/dark toggle) or that
// it rendered as untranslated literals.
const shellEn = {
  theme: "Theme",
  dark_mode: "Dark mode",
  loading: "Loading",
  // A Super admin viewing the dashboard as another user, opened from the admin panel.
  view_as_banner: "You are viewing the dashboard as {{email}}. Read-only: nothing can be changed.",
  act_as_banner:
    "You are acting as {{email}}. Changes are recorded as made by you on their behalf.",
  view_as_return: "Return to my account",
  view_as_failed: "Could not view the dashboard as that user: {{message}}",
};
const shellDe = {
  theme: "Design",
  dark_mode: "Dunkelmodus",
  loading: "Wird geladen",
  view_as_banner:
    "Sie sehen das Dashboard als {{email}}. Nur lesend: es kann nichts geändert werden.",
  act_as_banner:
    "Sie handeln als {{email}}. Änderungen werden als von Ihnen in deren Namen vorgenommen protokolliert.",
  view_as_return: "Zurück zu meinem Konto",
  view_as_failed: "Ansicht des Dashboards als dieser Benutzer nicht möglich: {{message}}",
};

// Screen copy the React views rendered as raw English literals, so t() could never reach it:
// the Workflows rule builder/table and the public Registration page. Keys the React code already
// had an equivalent for are NOT repeated here — these screens reuse `delete`, `cancel`, `close`,
// `asset`, `email`, `success`, `error_occured`, `refresh`, `sign_up`, `workflows`,
// `field_required`, `email_invalid` from baseEn/baseDe.
//
// German is deliberately partial, the same way the ported React dictionary is: a key whose German
// this port cannot get right is left out entirely so i18n.svelte.js falls back to English, rather
// than shipping wrong German. Each omission is commented at its English key.
const screensEn = {
  // --- Workflows -------------------------------------------------------------------------
  add_new_workflow: "Add new workflow",
  workflow: "Workflow",
  enabled: "Enabled",
  add_workflow: "Add workflow",
  workflow_created: "New client workflow created",
  workflow_deleted: "Workflow deleted",
  workflow_delete_confirm: "This workflow will be deleted.",
  no_workflows: "No workflows.",
  are_you_sure: "Are you sure?",
  asset_to_buy: "Asset to buy",
  // The rule sentence is assembled from fragments around the two <select>s ("When [x] is
  // deposited, convert it to [y] using market order."). German is left out for all five: the
  // subordinate clause and the separable verb "umwandeln" put the verbs at positions this
  // fragment split cannot express, so a translated fragment set would produce broken word order.
  // Rendering the sentence in German needs the markup restructured, not a dictionary entry.
  workflow_when: "When",
  workflow_is_deposited: "is deposited,",
  workflow_convert_to: "convert it to",
  workflow_using_market_order: "using market order.",
  // Same reason plus the deposit vocabulary this port will not guess at.
  deposit_asset: "Deposit asset",

  // --- Registration ----------------------------------------------------------------------
  password: "Password",
  sign_up_to: "Sign up to {{brand}}",
  registration_success_message: "Go to your inbox to confirm your email",
  registration_error_title: "Error occured!",
  please_try_again: "Please try again",
  // Shown instead of the sign-up form when the invitation cannot be redeemed. One wording per way it
  // can be refused, chosen from the API's `errorCode`: these used to be a single sentence covering
  // all of them, so somebody holding a link an admin had revoked was told only that it "is not
  // valid" — which is also what a typo says, and neither they nor support could tell which.
  invitation_not_valid: "This invitation link is not valid",
  invitation_not_valid_message: "Ask your administrator to send you a new invitation.",
  invitation_revoked: "This invitation has been revoked",
  invitation_revoked_message:
    "It was cancelled by an administrator. Ask them for a new invitation link.",
  invitation_expired: "This invitation has expired",
  invitation_expired_message:
    "Invitation links are valid for a limited time. Ask your administrator for a new one.",
  invitation_used: "This invitation has already been used",
  invitation_used_message: "An account was created with this link. Try logging in instead.",
  // Shown ABOVE the form, not instead of it: the invitation was never refused, we just could not
  // reach the API to check it, and that is not evidence against the invitation.
  invitation_check_failed: "We could not check your invitation",
  invitation_check_failed_message: "You can continue — it will be checked when you sign up.",
  already_have_account: "Already have an account?",
  login: "Login",
  password_should_contain: "Password should contain:",
  password_too_weak: "Too weak",
  pwd_number: "Number",
  pwd_lowercase: "Lowercase character",
  pwd_uppercase: "Uppercase character",
  pwd_special: "Special character",
  pwd_min_length: "At least 8 characters",
  // Auth0 refuses a password carrying the person's own address, so the form says so where the mistake is made.
  // Worded as the fix ("cannot contain") rather than as the rule's name, and it names the email specifically —
  // "must not contain user information" leaves somebody guessing which information.
  pwd_no_email: "None of your email address",
  pwd_contains_email: "Password cannot contain your email address or the part before the @",
  // The two the API can still refuse that this form does not pre-check.
  password_too_weak_error: "Password is too weak. Use a longer one with more character types",
  pwd_too_common: "Password is too common. Choose one that is harder to guess",
};
const screensDe = {
  add_new_workflow: "Neuen Workflow hinzufügen",
  workflow: "Workflow",
  enabled: "Aktiviert",
  add_workflow: "Workflow hinzufügen",
  workflow_created: "Neuer Kunden-Workflow erstellt",
  workflow_deleted: "Workflow gelöscht",
  workflow_delete_confirm: "Dieser Workflow wird gelöscht.",
  no_workflows: "Keine Workflows.",
  are_you_sure: "Sind Sie sicher?",
  asset_to_buy: "Zu kaufendes Asset",

  password: "Passwort",
  sign_up_to: "Registrieren bei {{brand}}",
  registration_success_message: "Öffnen Sie Ihr Postfach, um Ihre E-Mail-Adresse zu bestätigen",
  registration_error_title: "Es ist ein Fehler aufgetreten!",
  please_try_again: "Bitte versuchen Sie es erneut",
  invitation_not_valid: "Dieser Einladungslink ist nicht gültig",
  invitation_not_valid_message: "Bitten Sie Ihren Administrator um eine neue Einladung.",
  invitation_revoked: "Diese Einladung wurde widerrufen",
  invitation_revoked_message:
    "Sie wurde von einem Administrator zurückgezogen. Bitten Sie um einen neuen Einladungslink.",
  invitation_expired: "Diese Einladung ist abgelaufen",
  invitation_expired_message:
    "Einladungslinks sind nur begrenzt gültig. Bitten Sie Ihren Administrator um einen neuen.",
  invitation_used: "Diese Einladung wurde bereits verwendet",
  invitation_used_message:
    "Mit diesem Link wurde bereits ein Konto erstellt. Melden Sie sich stattdessen an.",
  invitation_check_failed: "Ihre Einladung konnte nicht geprüft werden",
  invitation_check_failed_message:
    "Sie können fortfahren — sie wird bei der Registrierung geprüft.",
  already_have_account: "Sie haben bereits ein Konto?",
  login: "Anmelden",
  password_should_contain: "Das Passwort sollte enthalten:",
  password_too_weak: "Zu schwach",
  pwd_number: "Zahl",
  pwd_lowercase: "Kleinbuchstabe",
  pwd_uppercase: "Großbuchstabe",
  pwd_special: "Sonderzeichen",
  pwd_min_length: "Mindestens 8 Zeichen",
  pwd_no_email: "Keinen Teil Ihrer E-Mail-Adresse",
  pwd_contains_email: "Das Passwort darf nicht Ihre E-Mail-Adresse oder den Teil davor enthalten",
  password_too_weak_error:
    "Das Passwort ist zu schwach. Verwenden Sie ein längeres mit mehr Zeichenarten",
  pwd_too_common: "Das Passwort ist zu häufig. Wählen Sie ein schwerer zu erratendes",
};

// Strings the React screens rendered as raw English literals, so they never translated. Named
// centrally rather than per screen, because several are shared (a "Clear filters" button exists on
// five screens) and independent naming would have produced five keys for one string.
//
// German follows the file's existing rule: translate where the term is unambiguous, and leave the
// key out entirely where it is not (i18n.svelte.js falls back to English). Financial vocabulary —
// payout offers, source assets, callbacks — is left English rather than guessed.
const screenTextEn = {
  // Shared across the table screens
  clear_filters: "Clear filters",
  all: "All",
  confirm: "Confirm",
  create: "Create",
  action: "Action",
  download_pdf: "Download PDF",

  // Deposits / deposit addresses
  no_deposits: "No deposits.",
  no_deposit_addresses: "No deposit addresses.",
  no_deposit_methods: "No deposit methods.",

  // Ledger / balances
  no_ledger_entries: "No ledger entries.",
  all_operations_for_id: "All operations for id: {{id}}",
  current_balances: "Current balances",
  account_value: "Account value",
  fiat_balances: "Fiat balances",
  coin_balances: "Coin balances",

  // Client info / API keys
  client_legal_name: "Legal Name",
  select_all: "Select all",
  api_key_permissions: "Select API Key permissions:",
  add_ip_address: "Add IP Address",
  ip_address: "IP Address",
  allowed_ip_addresses: "Allowed IP Addresses",
  no_ip_addresses_yet: "No IP addresses yet.",
  ip_address_added: "Successfully added new ip address",
  generate_callback_secret_question: "Do you want to generate a new callback secret?",
  error_occured_title: "Error occured",

  // Payouts
  create_payout: "Create Payout",
  prepare_payout_offer: "Prepare a payout offer",
  payout_method: "Payout method",
  source_asset: "Source asset",
  select_asset: "Select asset",
  charge_me_in: "Charge me in...",
  i_know_amount: "I know {{asset}} amount",
  callback_url_optional: "Callback URL (optional)",
  resend_callback: "Resend callback",
  callback_resent: "Successfully resent callback",
  payout_added: "Successfully added new payout",
  no_payouts: "No payouts.",
  remaining: "Remaining",
  seconds: "seconds",

  // Trading
  include_tx_fee: "Include transaction fee in exchange rate",
  no_trades: "No trades.",

  // Withdrawals
  no_withdrawals: "No withdrawals.",
  no_withdrawal_addresses: "No withdrawal addresses.",
  no_bank_accounts: "No bank accounts.",

  // Client info
  no_api_keys: "No API keys.",
  payment_link_fees: "Payment link fees",

  // Payout wizard steps. React numbered these in the label ("Step 1 - …"); the numbering is
  // structural, so it stays out of the translated string and is rendered from the step index.
  payout_step_send_asset: "Select asset to send",
  payout_step_charge_asset: "Select asset in which you want to be charged",
  payout_step_amount: "Provide amount",
  payout_step_address: "Provide address and optional information",
  description_optional: "Description (optional)",
  external_id_optional: "External ID (optional)",

  // Payment links. Note `amlreview` already exists for the screens that translate a status by
  // lowercasing it (`t(status.toLowerCase())`); these are the explicitly-named equivalents used
  // where the status is mapped through a label table instead.
  paid: "Paid",
  amount_due: "Amount due (incl. transaction fee)",
  outstanding: "Outstanding",
  outstanding_note: "The payer has sent less than the amount due.",
  partly_paid: "Partly paid",
  unpaid: "Unpaid",
  expired: "Expired",
  rejected: "Rejected",
  in_review: "In review",
  payment_in_review: "Payment in review",
  draft_rejected: "Draft rejected",
  created_at: "Created at",
  expires_at: "Expires at",
  url: "URL",
  locked_payment: "Locked payment",
  declared_payer_addresses: "Declared payer addresses",
  additional_comments: "Additional comments",
  no_payments_yet: "No payments yet.",
  none_declared: "None declared",
  none_attached: "None attached",
  customer_support: "Customer support",
  view_the_payment_link: "View the payment link",
  create_payment_link: "Create payment link",
  edit_payment_link: "Edit payment link",
  delete_payment_link: "Delete payment link",
  payment_link_delete_confirm: "Are you sure you want to delete this payment link?",
  draft: "Draft",
  confirmed: "Confirmed",
  flagged_by_aml: "Flagged by AML",
  unknown_payer: "Unknown payer",
  draft_approved: "Draft approved.",
  no_payment_links: "No payment links.",
  payment_link_number: "Payment link #{{id}}",
  pending_payment_link_number: "Pending payment link #{{id}}",
  // One key, not a prefix/suffix pair: splitting a sentence around an interpolated value forces
  // English word order onto every other language.
  contact_support_for_assistance: "Please contact {{email}} for further assistance.",
  payment_link_added: "Successfully added new payment link",
  payment_link_delete_body: "The payment link will no longer accept payments.",
  // Compliance document slots on the MLRO-gated payment-link wizard. The API sends enum codes
  // (Passport, PurchaseAgreement, …); these are the human labels for them.
  document_passport: "Passport",
  document_purchase_agreement: "Signed purchase agreement",
  document_proof_of_address: "Proof of address",
  document_source_of_funds: "Source of funds",

  // Shown to staff acting on a customer's account.
  impersonation_warning:
    "You are logged in as {{client}}. Any actions done will affect this client's account.",

  // The framing around the terms document. Without it the gate drops 45 kB of legal text on the
  // user with no explanation of why it appeared.
  terms_greeting: "Dear Customer,",
  terms_intro_updated:
    "We’ve updated our Terms and Conditions to better reflect our services and ensure clarity for you.",
  terms_intro_review:
    "Please review them below. To continue using our services, confirm your acceptance of the updated Terms and Conditions:",
  terms_questions: "If you have any questions, feel free to reach out to us at {{email}}",
};

const screenTextDe = {
  clear_filters: "Filter zurücksetzen",
  all: "Alle",
  confirm: "Bestätigen",
  create: "Erstellen",
  action: "Aktion",
  download_pdf: "PDF herunterladen",

  no_deposits: "Keine Einlagen.",
  no_deposit_addresses: "Keine Einzahlungsadressen.",
  no_deposit_methods: "Keine Einzahlungsmethoden.",

  no_ledger_entries: "Keine Hauptbucheinträge.",
  all_operations_for_id: "Alle Vorgänge für ID: {{id}}",
  current_balances: "Aktuelle Guthaben",
  fiat_balances: "Fiat-Guthaben",
  coin_balances: "Coin-Guthaben",

  select_all: "Alle auswählen",
  add_ip_address: "IP-Adresse hinzufügen",
  ip_address: "IP-Adresse",
  allowed_ip_addresses: "Erlaubte IP-Adressen",
  no_ip_addresses_yet: "Noch keine IP-Adressen.",
  error_occured_title: "Fehler aufgetreten",

  no_payouts: "Keine Auszahlungen.",
  remaining: "Verbleibend",
  seconds: "Sekunden",

  no_trades: "Keine Trades.",

  no_withdrawals: "Keine Abhebungen.",
  no_withdrawal_addresses: "Keine Auszahlungsadressen.",
  no_bank_accounts: "Keine Bankkonten.",

  no_api_keys: "Keine API-Schlüssel.",

  paid: "Bezahlt",
  amount_due: "Fälliger Betrag (inkl. Transaktionsgebühr)",
  outstanding: "Offen",
  outstanding_note: "Der Zahler hat weniger als den fälligen Betrag gesendet.",
  partly_paid: "Teilweise bezahlt",
  unpaid: "Unbezahlt",
  expired: "Abgelaufen",
  rejected: "Abgelehnt",
  in_review: "In Prüfung",
  payment_in_review: "Zahlung in Prüfung",
  created_at: "Erstellt am",
  expires_at: "Läuft ab am",
  url: "URL",
  additional_comments: "Zusätzliche Kommentare",
  no_payments_yet: "Noch keine Zahlungen.",
  customer_support: "Kundensupport",
  create_payment_link: "Zahlungslink erstellen",
  edit_payment_link: "Zahlungslink bearbeiten",
  delete_payment_link: "Zahlungslink löschen",
  draft: "Entwurf",
  confirmed: "Bestätigt",
  unknown_payer: "Unbekannter Zahler",
  draft_approved: "Entwurf genehmigt.",
  no_payment_links: "Keine Zahlungslinks.",
  payment_link_number: "Zahlungslink #{{id}}",
  payment_link_delete_body: "Der Zahlungslink akzeptiert keine Zahlungen mehr.",
  document_passport: "Reisepass",
  document_proof_of_address: "Adressnachweis",

  terms_greeting: "Sehr geehrter Kunde,",
};

export const en = { ...baseEn, ...navEn, ...shellEn, ...screensEn, ...screenTextEn };
export const de = { ...baseDe, ...navDe, ...shellDe, ...screensDe, ...screenTextDe };

// Spanish and Portuguese live in their own modules: unlike German they are complete maps.
export { es } from "./es.js";
export { pt } from "./pt.js";
